import $ from "jquery";
import {domSelectors} from "~/globals";

export const $recaptchaToken = () => $(domSelectors.CaptchaValidation);
export const $googleSiteKey = () => $(domSelectors.GoogleSiteKey);
export const generaRecaptcha = async (action: string, silent = false) => {
    let refresh = async () => {
        let token = await grecaptcha.execute(window.RecaptchaKEY, { action: action });
        $recaptchaToken().val(token);
    }
    
    if (silent) {
        try {
            await refresh();
        } catch (e) {
            console.log("errore refresh token recaptcha.");
            console.log(e);
        }
    } else await refresh();
}

export const recaptchaReady = async () : Promise<void> => {
    return new Promise<void>((resolve, reject) => {
        grecaptcha.ready(() => {
            resolve();
        });
    });
}

export const recaptchaToken = () => $recaptchaToken().val() as string;